import React from 'react';
import { Icon } from './Icon.js';
export const IconFilePen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2V10H4", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 22L22.5 16.5L19.5 13.5L14 19V22H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 8.4668L19 10.4668V3H11.0059L5 9.00391V21H11V23H3V8.17578L3.29297 7.88281L9.88477 1.29297L10.1777 1H21V8.4668Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFilePen.js.map